import { render } from "./aijiu.vue?vue&type=template&id=1919fda0"
import script from "./aijiu.vue?vue&type=script&lang=js"
export * from "./aijiu.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__